class Accordion extends HTMLElement {
  constructor() {
    super();

    this.titleEl = this.querySelector("[data-accordion-title]");
    this.body = this.querySelector("[data-accordion-body]");
    if (this.hasAttribute("data-accordion-start-open")) this.open();
    else this.active = false;
  }

  connectedCallback() {
    this.titleEl.addEventListener("click", () => {
      this.handleAccordionClick();
    });
  }

  handleAccordionClick() {
    if (this.active) this.close();
    else this.open();
  }

  open() {
    this.classList.add("open");
    this.body.style.maxHeight = this.body.scrollHeight + "px";
    this.active = true;
  }

  close() {
    this.classList.remove("open");
    this.body.style.maxHeight = 0;
    this.active = false;
  }
}

customElements.define("accordion-el", Accordion);

class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.selector = this.querySelector("[data-select]");
    this.optionsWrapper = this.querySelector("[data-options]");
    this.options = this.querySelectorAll("[data-option]");
    this.isOpen = false;
    this.valueElement = this.querySelector("[data-selected-value]");
    if (this.options.length > 0) this.value = this.valueElement.dataset.selectedValue;
    else this.value = "";
  }

  connectedCallback() {
    this.selector.addEventListener("click", () => {
      this.handleSelectClick();
    });

    this.options.forEach((option) => {
      option.addEventListener("click", () => {
        this.selectValue(option);
      });
    });

    if(this.optionsWrapper) {
      this.optionsWrapper.addEventListener("click", () => {
        this.close();
      });
    }
  }

  handleSelectClick() {
    if (this.isOpen) this.close();
    else this.open();
  }

  open() {
    this.classList.add("open");
    this.isOpen = true;
  }

  close() {
    this.classList.remove("open");
    this.isOpen = false;
  }

  selectValue(option) {
    this.value = option.dataset.value;
    this.valueElement.innerHTML = option.innerHTML;
    this.valueElement.dataset.selectedValue = this.value;
    this.close();

    const event = new CustomEvent("value-changed", {
      detail: {
        newValue: this.value
      }
    });

    this.dispatchEvent(event);
  }
}

customElements.define("custom-select", CustomSelect);